export default __webpack_public_path__ + "static/media/crc-block-cc.6b14f1c6.svg";